
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {Schema} from "./demo/schema";
function _createMdxContent(props) {
  const _components = {
    h3: "h3",
    p: "p",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h3, {
      children: "Overview"
    }), "\n", _jsx(_components.p, {
      children: "Schema for constraint solver."
    }), "\n", _jsx(Schema, {})]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}


export const metadata = {"size":"0.1 KB","lastModified":"12/22/2025","path":"/opt/render/project/src/packages/app/src/blog/protologic/constraint-solver/semantic-schema/post.mdx"};
export const raw = "import { Schema } from \"./demo/schema\";\n\n### Overview\n\nSchema for constraint solver.\n\n<Schema />\n";
